var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related-performances"},[(!_vm.performancesLoading)?_c('BlockHorizontalList',{attrs:{"title":"Fler konserter","subtitle":_vm.subtitle,"type":"shows","shows":_vm.filteredPerformances}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }